import React from 'react';
import { Inline } from '@atlaskit/primitives/compiled';
import { Feedback } from '@atlassian/jira-atlassian-intelligence/src/ui/feedback/index.tsx';
import type { SearchModeSwitcherProps } from '@atlassian/jira-jql-builder/src/common/types.tsx';
import { DisclaimerTooltip } from './disclaimer-tooltip/index.tsx';
import { SearchModeOverflowMenu } from './search-mode-overflow-menu/index.tsx';

export const SearchModeSwitcher = (props: SearchModeSwitcherProps) => (
	<Inline space="space.100" alignBlock="center">
		<Feedback />
		<DisclaimerTooltip />
		<SearchModeOverflowMenu {...props} />
	</Inline>
);
